import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Me } from '../api';
import { useBrand } from '../theme';
import { ContextSwitcher } from './ContextSwitcher';
import { ReleaseBadge } from './ReleaseBadge';
import { TopbarTools } from './TopbarTools';

/**
 * The top bar for screens outside a project (Home's empty state, Learning, Administration): brand · organisation ·
 * Dashboard · Portfolio · an optional title · 🔔 · avatar menu. The project screens add the project switcher and + New project themselves.
 */
export function AppTopbar({ me, children }: { me: Me; children?: ReactNode }) {
  const { t } = useTranslation();
  const { brand, logoUrl } = useBrand(me.tenant.id);
  return (
    <header className="topbar">
      <Link to="/" className="brand">
        {logoUrl ? (
          <img className="brand-logo" src={logoUrl} alt={brand?.effective.name ?? ''} />
        ) : (
          <>
            <img src="/favicon.svg" alt="" width={22} height={22} />
            Fyr
          </>
        )}
        <ReleaseBadge />
      </Link>
      <ContextSwitcher
        contexts={me.contexts}
        activeTenantId={me.tenant.id}
        activeName={brand?.effective.name}
      />
      <Link to="/dashboard" className="topbar-link">
        {t('tree.myDashboard')}
      </Link>
      <Link to="/portfolio" className="topbar-link">
        {t('programmes.portfolio')}
      </Link>
      {children}
      <div className="spacer" />
      <TopbarTools me={me} />
    </header>
  );
}
